import React from 'react';
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import MessageUI from '../widgets/output/MessageUI'
import prjLogoLite from '../assets/projectapp/lite_left/color_logo_transparent.png'
import prjLogoDark from '../assets/projectapp/dark_left/color_logo_transparent.png'
import finLogo from '../assets/finapp/logo128.png'
import TopNavLinkUI from '../widgets/output/TopNavLinkUI'
import './HeaderLeft.css'

const HeaderLeftUI = ({context, history, backLink, onToggleSidebar,
    headerText, messageList, headerMessageKey, headerMessageArgs, subHeaderText, account, loan}) =>
  <div className='t_hleft g_flex_h'>
    {
      context && context.permissions && context.permissions.includes('su_view') &&
      <span className='icon icon-bars g_muted g_cursor_pointer g_m_right_100 g_xxlarge g_m_top_50'
        onClick={onToggleSidebar}
      />
    }
    <HeaderIconUI context={context} history={history} backLink={backLink} headerText={headerText} headerMessageKey={headerMessageKey} />
    <HeaderTextUI context={context} headerText={headerText} messageList={messageList}
      headerMessageKey={headerMessageKey} headerMessageArgs={headerMessageArgs}
      subHeaderText={subHeaderText} account={account}
    />
    <HeaderText2UI account={account} loan={loan} />
  </div>

const HeaderIconUI = ({context, history, backLink, headerText, headerMessageKey}) =>
  <React.Fragment>
    <Link className='logo_desktop' to='/'>
      {
        context.session.appCode === 'projectapp' &&
        <img src={context.theme === 'lite' ? prjLogoLite : prjLogoDark} alt="" />
      }
      {
        context.session.appCode === 'finapp' &&
        <div className='g_flex_h'>
          <img src={finLogo} alt="" />
        </div>
      }
    </Link>
    {
      !backLink && !headerText && !headerMessageKey &&
      <Link className='logo_mobile' to='/'>
        {
          context.session.appCode === 'projectapp' &&
          <img src={context.theme === 'lite' ? prjLogoLite : prjLogoDark} alt="" />
        }
        {
          context.session.appCode === 'finapp' &&
          <img src={finLogo} alt="" />
        }
      </Link>
    }
    {
      backLink === '#' &&
      <span className="back_link" onClick={() => history.goBack()}>
        <div className="icon icon-caret-left"></div>
      </span>
    }
    {
      backLink &&
      <Link className="back_link" to={backLink}>
        <div className="icon icon-caret-left"></div>
      </Link>
    }
  </React.Fragment>

const HeaderTextUI = ({context, headerText, messageList, headerMessageKey, headerMessageArgs, subHeaderText, account}) =>
  <span className='header_text'>
    {/*
      headerText &&
      <React.Fragment>{headerText}</React.Fragment>
      */}
    {/*
      headerMessageKey &&
      <React.Fragment>
        <MessageUI messageList={messageList} messageKey={headerMessageKey} args={headerMessageArgs} />
        {
          subHeaderText &&
          <span className='g_muted g_m_left_50'>{subHeaderText}</span>
        }
      </React.Fragment>
    */}
    {/*      <TopNavLinkUI label='aas' to='/su/settings' active={true} />*/}

    {/*
      account &&
      <TopNavLinkUI label={account.shortName} to='/su/settings' active={true} />
    */}
  </span>

const HeaderText2UI = ({account, loan}) =>
  <>
    {
      account &&
      <div className='g_flex_h g_m_left_100'>
        <TopNavLink2UI label={account.shortName} to={`/su/accounts/${account.accountId}`} active={true} />
      </div>
    }
    {
      loan &&
      <div className='g_flex_h g_m_left_100'>
        <TopNavLink2UI label={loan.accountName} to={`/su/accounts/${loan.accountId}`} />
        /
        <TopNavLink2UI label={
            (loan.parentLRN ? loan.parentLRN + ' > ' : '') + loan.loanRefNum + ' | ' + loan.loanName} to={`/su/loans/${loan.loanId}`} 
            active={true} />
      </div>
    }
  </>

const TopNavLink2UI = ({label, to, active}) =>
  <Link to={to} className={`top_nav g_no_wrap_2 ${active ? 'active' : ''}`}>
    {label}
  </Link>

export default withRouter(HeaderLeftUI)
